import { useEffect, useState } from "react"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import { AMANAGE_APP_SETTING_API } from "../../../../Utilities/APIs/APIs"
import Form from "../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import SwitchInput from "../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput"
import ImageInput from "../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput"
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"





function UpdateAppSettings({targetID, setShowUpdateForm, setShowModal, triggerFetch

}) {
    const [name, setName] = useState('')
   const [isCategoryFeatured, setIsCategoryFeatured] = useState(false)
    const [image, setImage] = useState()

    const axiosInstance = useAxiosInstance()

    

    useEffect(() => {

        async function fetchAndSetCategory() {

            const { data } = await axiosInstance.get(AMANAGE_APP_SETTING_API + 'getSingleAppSettings/' + targetID)
            setName(data?.name);
            setIsCategoryFeatured(data?.isCategoryFeatured);
            setImage(data?.image);
        }
        fetchAndSetCategory()
    }, [axiosInstance, targetID])


    async function handleSubmit(e) {
        e.preventDefault()
        const itemData = new FormData()

        itemData.append('name', name)
        itemData.append('isCategoryFeatured', isCategoryFeatured)
        itemData.append('image', image)

        const response = await axiosInstance.patch(AMANAGE_APP_SETTING_API + targetID ,itemData)

        if (response) {

            setShowUpdateForm(false);
            setShowModal(false);
            triggerFetch()
        }
    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <ShortTextInput
                label= "Name"
                placeholder='Enter name'
                value={name}
                setState={setName}

            />
            <ShortTextInput
                label= "is Category Featured"
                placeholder='Enter description'
                value={isCategoryFeatured}
                setState={setIsCategoryFeatured}

            />
             <SwitchInput
                label={'Is Category Featured'}
                toggleSwitch={() => setIsCategoryFeatured(prevState => !prevState)}
                checked={isCategoryFeatured}
            />
            <ImageInput state={image} setState={setImage} allowUpdateImage>Upload Image</ImageInput>

            <FormSubmitButton text='Update AppSettings' />
        </Form>
    )
}
export default UpdateAppSettings